<div class="relative">
  <button class="bg-gray-6 rounded-full p-1 flex items-center shadow-fution-small hover:bg-light-blue hover:opacity-70 hover:text-lighter focus:bg-light-blue focus:text-lighter" (click)="toggleMenu()">
    <span class="material-symbols-rounded leading-none">person</span>
  </button>
  <div class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-b-lg bg-white focus:outline-none p-2"
    [hidden]="!menuOpen" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
    <div class="flex flex-col gap-4">
      <a class="text-gray-2 text-smPlus font-light cursor-pointer" role="menuitem" tabindex="-1" (click)="changePassword()">Cambiar contraseña</a>
      <a *ngIf="role === 'VV-CL-ADMIN'" class="text-gray-2 text-smPlus font-light cursor-pointer" role="menuitem" tabindex="-1" (click)="users()">Mis Usuarios</a>
      <a class="text-gray-2 text-smPlus font-light cursor-pointer" role="menuitem" tabindex="-1" (click)="emailList()">Lista de Correos</a>
      <a class="text-gray-2 text-smPlus font-light cursor-pointer" role="menuitem" tabindex="-1" (click)="logOut()">Cerrar sesión</a>
    </div>
  </div>
</div>

<app-modal-password name="modalPassword"></app-modal-password>

<app-modal-close-session></app-modal-close-session>